import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner as BaseSpinner, Box } from "native-base";
const Spinner = () => (_jsx(Box, Object.assign({ alignItems: "center", p: 8 }, { children: _jsx(BaseSpinner, { color: "green.300", size: "lg", accessibilityLabel: "Bet\u00F6lt\u00E9s\u2026" }) })));
export default Spinner;
